import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'latLngPosition',
    standalone: false,
})
export class LatLngPositionPipe implements PipeTransform {
    transform<T>(value: { lat: any; lng: any }): google.maps.LatLngLiteral {
        return {
            lat: +value.lat,
            lng: +value.lng,
        };
    }
}
